import { MenuItem } from "@headlessui/react";
import classNames from "classnames";
import { ReactNode } from "react";
import { useTheme } from "../../../context/theme/useTheme";

export const DropdownOption = (props: Props) => {
    const { onClick, className, children, isFirst, isLast, isActive } = props;
    const { isDarkMode } = useTheme();

    return ( 
        <MenuItem>
            {({ focus }) => (
                <button
                    disabled={isActive}
                    onClick={onClick}
                    className={classNames(
                        className,
                        !isActive && (isDarkMode ? 'hover:bg-white/10' : 'hover:bg-black/10'),
                        focus && 'font-medium',
                        'relative flex group items-center justify-start px-4 py-2 w-full gap-2.5',
                        isFirst && 'rounded-t-md',
                        isLast && 'rounded-b-md'
                    )}
                >
                        <div className="flex justify-start items-center relative">
                            {children}
                            {isActive && <div className={classNames(isDarkMode ? 'bg-white' : 'bg-black', 'bg-opacity-80 absolute -right-4 h-1.5 w-1.5 rounded-full')} />}
                        </div>
                </button>
            )}
        </MenuItem>
    );
}

type Props = {
    className?: string;
    onClick: () => void;
    children: ReactNode;
    isFirst?: boolean;
    isLast?: boolean;
    isActive?: boolean;
};

